export const HISTORY_ACTION_LABELS: Record<string, string> = {
  Deposit: 'Deposit / tokens received',
  'Unstake requested': 'Withdrawal request',
  Withdraw: 'Withdraw',
  WithdrawalClaimed: 'Completed withdrawal',
};

export const HISTORY_TABS = [
  { id: 'all' as const, content: 'All' },
  { id: 'deposits' as const, content: 'Deposits' },
  { id: 'withdrawals' as const, content: 'Withdrawals' },
];
